import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import ButtonComponent from "@components/Theme/Button/Button"
import {
	AdvancedSideAssetModuleType,
	LogosModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"
import Marquee from "react-fast-marquee"

import styles from "./CustomerLogosSection.module.scss"

type Props = {
	data: LogosModuleType[]
	pageData: AdvancedSideAssetModuleType
}

const CustomerLogosSection = (props: Props) => {
	return (
		<>
			<ContainerWrapper>
				<Title
					className={styles.title}
					content={props.pageData.sectionTitle}
					fontWeight={600}
					size={"XL"}
					type={"2"}
					center
				/>
				<Separator size={32} />
			</ContainerWrapper>
			<Marquee className={styles.logosBox} speed={100} pauseOnHover>
				{props.data.map((element: LogosModuleType, index: number) => {
					return (
						<img
							key={index}
							alt={element.title}
							className={styles.image}
							loading={"lazy"}
							src={element.logo.src}
						/>
					)
				})}
			</Marquee>
			<Separator size={32} />
			<Separator textAlignCenter withoutMeasure>
				<ButtonComponent
					buttonType={"secondary"}
					link={props.pageData.sectionBottomButtonLink}
					asLink
				>
					{props.pageData.sectionBottomButton}
				</ButtonComponent>
			</Separator>

			<Separator size={128} />
		</>
	)
}

export default CustomerLogosSection
